var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    [
      _c(
        "b-alert",
        { staticClass: "mb-2", attrs: { variant: "info", show: "" } },
        [
          _c("div", { staticClass: "alert-body" }, [
            _vm._v(
              " Um cadastro — profissional autônomo ou estabelecimento — só aparece no marketplace e só pode vender depois de aprovado aqui. A aprovação exige o cadastro completo — a lista de pendências aparece ao abrir cada um. "
            ),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "mb-2 flex flex-row gap-2" },
        [
          _c(
            "b-button",
            {
              attrs: {
                variant:
                  _vm.personType === "NE" ? "primary" : "outline-primary",
                size: "sm",
              },
              on: {
                click: function ($event) {
                  return _vm.switchType("NE")
                },
              },
            },
            [_vm._v(" Profissionais ")]
          ),
          _c(
            "b-button",
            {
              staticClass: "ml-1",
              attrs: {
                variant:
                  _vm.personType === "LE" ? "primary" : "outline-primary",
                size: "sm",
              },
              on: {
                click: function ($event) {
                  return _vm.switchType("LE")
                },
              },
            },
            [_vm._v(" Estabelecimentos ")]
          ),
        ],
        1
      ),
      _c("Grid", {
        key: _vm.personType,
        ref: "grid",
        attrs: {
          service: _vm.gridService,
          forceFilters: _vm.gridFilters,
          hide_actions: true,
          route_name: "professionals",
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function (thead) {
              return [
                _vm._l(thead.data, function (column, key) {
                  return _c(
                    "vs-th",
                    {
                      key: key,
                      attrs: {
                        "sort-key": thead.methods.getColumnSortKey(key),
                        "sort-status": "asc",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.columnLabel(
                            thead.methods.getOriginalColumnName(column)
                          )
                        )
                      ),
                    ]
                  )
                }),
                _c("vs-th", [_vm._v("Habilitação")]),
                _c("vs-th", [_vm._v("Ação")]),
              ]
            },
          },
          {
            key: "gridData",
            fn: function (gridData) {
              return _vm._l(gridData.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _vm._l(gridData.columns, function (column, key) {
                      return _c(
                        "vs-td",
                        {
                          key: key,
                          attrs: { data: gridData.data[indextr].id },
                        },
                        [
                          _c(
                            "div",
                            {
                              class: gridData.methods.getColumnCss(
                                gridData.data[indextr],
                                key
                              ),
                            },
                            [
                              _c("div", {
                                directives: [
                                  {
                                    name: "html-safe",
                                    rawName: "v-html-safe",
                                    value:
                                      "<div>" +
                                      gridData.methods.getColumnData(
                                        gridData.data[indextr],
                                        key
                                      ) +
                                      "</div>",
                                    expression:
                                      "`<div>${gridData.methods.getColumnData(gridData.data[indextr],key)}</div>`",
                                  },
                                ],
                                key: key,
                              }),
                            ]
                          ),
                        ]
                      )
                    }),
                    _c(
                      "vs-td",
                      [
                        _c(
                          "b-badge",
                          {
                            attrs: {
                              variant: _vm.kycVariant(
                                gridData.data[indextr].kyc_status
                              ),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.kycLabel(
                                    gridData.data[indextr].kyc_status
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("vs-td", [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-2" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { size: "sm", variant: "outline-primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openReview(gridData.data[indextr])
                                },
                              },
                            },
                            [_vm._v(" Analisar ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                )
              })
            },
          },
        ]),
      }),
      _c(
        "b-modal",
        {
          attrs: {
            title:
              "Analisar: " + (_vm.selected ? _vm.selected.trading_name : ""),
            size: "lg",
            "hide-footer": "",
          },
          model: {
            value: _vm.showReview,
            callback: function ($$v) {
              _vm.showReview = $$v
            },
            expression: "showReview",
          },
        },
        [
          _vm.selected
            ? _c(
                "div",
                [
                  _c("p", { staticClass: "mb-1" }, [
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.selected.document_label || "Documento") + ":"
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.selected.document_fmt ||
                            _vm.selected.cnpj_formmated
                        ) +
                        "  ·  "
                    ),
                    _c("strong", [_vm._v("Situação:")]),
                    _vm._v(
                      " " + _vm._s(_vm.kycLabel(_vm.selected.kyc_status)) + " "
                    ),
                  ]),
                  _c("h5", { staticClass: "mt-2" }, [
                    _vm._v("Pendências do cadastro"),
                  ]),
                  _c(
                    "ul",
                    { staticClass: "list-unstyled" },
                    _vm._l(_vm.checklist, function (item) {
                      return _c(
                        "li",
                        { key: item.key, staticClass: "mb-25" },
                        [
                          _c("feather-icon", {
                            staticClass: "h-4 w-4 mr-50",
                            class: item.ok ? "text-success" : "text-danger",
                            attrs: {
                              icon: item.ok
                                ? "CheckCircleIcon"
                                : "AlertCircleIcon",
                            },
                          }),
                          _c("span", { class: item.ok ? "" : "text-danger" }, [
                            _vm._v(_vm._s(item.label)),
                          ]),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  !_vm.hasPendings
                    ? _c("p", { staticClass: "text-muted" }, [
                        _vm._v(
                          "Nenhuma pendência — o cadastro pode ser aprovado."
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-1",
                      attrs: {
                        size: "sm",
                        variant: "outline-primary",
                        disabled: _vm.loadingDetails,
                      },
                      on: { click: _vm.toggleDetails },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: {
                          icon: _vm.showDetails
                            ? "ChevronUpIcon"
                            : "FileTextIcon",
                        },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.showDetails
                              ? "Ocultar dados do cadastro"
                              : "Ver dados do cadastro"
                          ) +
                          " "
                      ),
                    ],
                    1
                  ),
                  _vm.showDetails
                    ? _c(
                        "div",
                        { staticClass: "kyc-details mt-2" },
                        [
                          _vm.loadingDetails
                            ? _c("p", { staticClass: "text-muted mb-0" }, [
                                _vm._v("Carregando..."),
                              ])
                            : _vm.details
                            ? _vm._l(_vm.detailBlocks, function (bloco) {
                                return _c(
                                  "div",
                                  { key: bloco.titulo, staticClass: "mb-2" },
                                  [
                                    _c(
                                      "h6",
                                      { staticClass: "text-primary mb-50" },
                                      [_vm._v(_vm._s(bloco.titulo))]
                                    ),
                                    !bloco.linhas.length
                                      ? _c(
                                          "p",
                                          { staticClass: "text-muted mb-0" },
                                          [
                                            _c("small", [
                                              _vm._v("Não informado."),
                                            ]),
                                          ]
                                        )
                                      : _c(
                                          "table",
                                          { staticClass: "kyc-details-table" },
                                          _vm._l(
                                            bloco.linhas,
                                            function (linha) {
                                              return _c(
                                                "tr",
                                                { key: linha.rotulo },
                                                [
                                                  _c("th", [
                                                    _vm._v(
                                                      _vm._s(linha.rotulo)
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(_vm._s(linha.valor)),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                  ]
                                )
                              })
                            : _c("p", { staticClass: "text-danger mb-0" }, [
                                _c("small", [
                                  _vm._v(
                                    "Não foi possível carregar os dados do cadastro."
                                  ),
                                ]),
                              ]),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mt-2",
                      attrs: {
                        label: "Parecer / motivo",
                        "label-for": "notes",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "notes",
                          rows: "3",
                          placeholder:
                            "Obrigatório ao recusar. Vai no e-mail de resposta ao parceiro.",
                        },
                        model: {
                          value: _vm.notes,
                          callback: function ($$v) {
                            _vm.notes = $$v
                          },
                          expression: "notes",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end gap-2 mt-2" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-secondary" },
                          on: {
                            click: function ($event) {
                              _vm.showReview = false
                            },
                          },
                        },
                        [_vm._v("Fechar")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-1",
                          attrs: { variant: "outline-danger" },
                          on: { click: _vm.reject },
                        },
                        [_vm._v("Recusar")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-1",
                          attrs: {
                            variant: "primary",
                            disabled: _vm.hasPendings,
                          },
                          on: { click: _vm.approve },
                        },
                        [_vm._v(" Aprovar ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }